import { SurveyQuestionDTO } from "./SurveyQuestionDTO";

export class SurveyDTO {
    public surveyId: string;
    public surveyTitle: string;
    questions: SurveyQuestionDTO[];

    constructor(private _id: string, private name: string) {
        this.surveyId = _id;
        this.surveyTitle = this.name;
    }
}
